import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  AbstractControl
} from '@angular/forms';
import { ArcValidators, AppConfigSettings } from '@arc/arc-shared-frontend';

@Component({
  selector: 'app-authentication-passwordreset',
  templateUrl: './passwordreset.component.html',
  styleUrls: ['./passwordreset.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordresetComponent implements OnInit {
  @Output()
  resetPasswordClicked = new EventEmitter<any>();

  @Output()
  goBackClicked = new EventEmitter<any>();
  @Input()
  backButtonVisible = true;

  labelPrefix = '';
  passwordFormGroup: UntypedFormGroup;

  constructor(public settings: AppConfigSettings) {}

  ngOnInit() {
    this.passwordFormGroup = new UntypedFormGroup(
      {
        passwordConfirm1: new UntypedFormControl('', {
          validators: [
            Validators.required,
            ArcValidators.minLength(8),
            ArcValidators.oneLowerCase,
            ArcValidators.oneUpperCase,
            ArcValidators.oneSpecialCharacter,
            ArcValidators.oneNumber
          ],
          updateOn: 'change'
        }),
        passwordConfirm2: new UntypedFormControl('', {
          updateOn: 'change'
        })
      },
      {
        validators: [
          ArcValidators.fieldMatch('passwordConfirm1', 'passwordConfirm2')
        ],
        updateOn: 'blur'
      }
    );

    this.passwordFormGroup
      .get('passwordConfirm2')
      .setValidators([
        Validators.required,
        ArcValidators.fieldMatch(
          'passwordConfirm1',
          'passwordConfirm2',
          this.passwordFormGroup
        )
      ]);
  }

  setPassword() {
    this.passwordFormGroup.updateValueAndValidity();
    if (this.passwordFormGroup.valid) {
      this.resetPasswordClicked.emit(
        this.passwordFormGroup.controls.passwordConfirm1.value
      );
    } else {
      this.passwordConfirm1.markAsTouched();
      this.passwordConfirm2.markAsTouched();
    }
  }

  get passwordConfirm1() {
    return this.passwordFormGroup.get('passwordConfirm1');
  }
  get passwordConfirm2() {
    return this.passwordFormGroup.get('passwordConfirm2');
  }

  get passwordConfirm1Changed() {
    return this.passwordConfirm1.touched;
  }

  get passwordConfirm1IsInValid() {
    return this.passwordConfirm1.errors && this.passwordConfirm1.touched;
  }
  get passwordConfirm2IsInValid() {
    return (
      (this.passwordConfirm2.errors ||
        (this.passwordFormGroup.errors &&
          this.passwordFormGroup.errors.fieldMatch)) &&
      this.passwordConfirm2.touched
    );
  }

  showError(control: AbstractControl, error: string): boolean {
    return control.touched && control.errors && control.errors[error];
  }

  showSuccess(control: AbstractControl, error: string): boolean {
    return (
      (control.dirty && !control.errors) ||
      (control.errors && !control.errors[error])
    );
  }

  goBack($event) {
    this.goBackClicked.emit();
  }
}
